import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePlatformKeyStatus } from '@/contexts/PlatformKeyStatusContext'
import { useUserRoleContext } from '@/contexts/UserRoleContext'
import { hasSupportAccess, isPlatformOwner } from '@/utils/roleUtils'
import { PlatformKeyBanner } from '@/design-system/molecules/PlatformKeyBanner'

function PlatformKeyBannerConnector() {
    const { isPlatformKeyMissing, loading } = usePlatformKeyStatus()
    const { role } = useUserRoleContext()
    const navigate = useNavigate()

    const visible = isPlatformKeyMissing && !loading && hasSupportAccess(role)
    const showCTA = isPlatformOwner(role)
    const handleCTAClick = useCallback(() => {
        void navigate('/admin/settings')
    }, [navigate])

    return <PlatformKeyBanner visible={visible} showCTA={showCTA} onCTAClick={handleCTAClick} />
}

export default PlatformKeyBannerConnector
